<template>
  <component :is="resolveLayout">
    <router-view></router-view>
  </component>
</template>

<script>
import { computed } from "@vue/composition-api";
import { useRouter } from "@/utils";
import LayoutBlank from "@/layouts/Blank";
import LayoutContent from "@/layouts/Content";

export default {
  components: {
    LayoutBlank,
    LayoutContent,
  },
  setup() {
    const { route } = useRouter();

    const resolveLayout = computed(() => {
      // Handles initial route
      if (route.value.name === null) return null;

      if (route.value.meta.layout === "blank") return "layout-blank";

      return "layout-content";
    });

    return {
      resolveLayout,
    };
  },
  async mounted() {
    const vm = this;
    setInterval(async function() {
      await vm.$fetcher.SendBeacon(true);
    }, 1000 * 60 * 20); // 20 mins pulse
  },
};
</script>
